import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { AlertService } from 'src/app/shared/providers/AlertProvider';

@Component({
  selector: 'app-report-module',
  templateUrl: './report-module.component.html',
  styleUrls: ['./report-module.component.scss']
})
export class ReportModuleComponent implements OnInit {
  filter: any = {
    region: '',
    month_year: '',
    start_date: '',
    end_date: ''
  }
  report: any = null;
  download: any = "";
  url: any;
  excelSheet: any;
  currentDate: any;
  regionList: any = []
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private alertService: AlertService
  ) { }
  reportList: any = [];

  ngOnInit() {
    this.getRegion()
    this.getReportList()
    this.formatDate();
  }
  getReportList() {
    this.apiService.get(this.apiConfig.getReportsList)
      .subscribe((res: any) => {
        this.reportList = res.data.reports;
        console.log(this.reportList, "reportList")
      })
  }
  getRegion() {
    this.apiService.get(this.apiConfig.configGetRegion).subscribe((res: any) => {
      console.log(res)
      this.regionList = res.data.region;
    })
  }

  changeReportType(e) {
    console.log(this.report)
  }

  formatDate() {
    this.currentDate = moment().format("YYYY-MM-DD");
  }

  reports() {
  }

  downloadExcelSheet() {
    setTimeout(() => {
      document.getElementById("downloadExcel").click();
    }, 500);
  }
  filterCallApi(e) {
    const monthYear = this.filter.month_year;
    const year = monthYear.split('-')[0];
    const month = monthYear.split('-')[1];
    console.log(this.filter.month_year, year, month)
    this.url = this.apiUrl(this.report, this.apiConfig);
    if (!this.validateFilterInputs()) {
      return;
    }
    this.apiService.get(this.url + `?program_id=1&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}&month=${month}&year=${year}&region_id=${this.filter.region}&report_id=${this.report.report_id}`).subscribe((res: any) => {
      console.log(res);
      this.excelSheet = res.data.report_data;
      if (this.excelSheet) {
        this.downloadExcelSheet()
      }
    })

    console.log(this.url)

  }
  apiUrl(report: any, apiConfig: any): string {
    if (report.baseurl == 1) {
      return apiConfig.baseUrl2 + report.endpoint;
    } else {
      return apiConfig.baseUrlForReport + report.endpoint;
    }
  }
  validateFilterInputs(): boolean {
    const dateFilter = this.report.datefilter;
    if (dateFilter === 1) {
      if (!this.filter.end_date) {
        alert("End Date is required.");
        return false;
      }
    } else if (dateFilter === 2) {
      if (!this.filter.month_year || !this.filter.region) {
        alert("Month, Year, and Region are required.");
        return false;
      }
    } else if (dateFilter !== 0) {
      this.alertService.error("Invalid date filter configuration.");
      return false;
    }
    return true;
  }

}
